import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Toggle-Schalter (MUI-`Switch`-Ersatz) auf Basis einer nativen Checkbox mit
 * `role="switch"`. Track + Thumb kommen aus `.sec-switch*`.
 */
export const Switch = forwardRef(function Switch({ className, ...rest }, ref) {
    return (_jsxs("span", { className: cn('sec-switch', className), children: [_jsx("input", { ref: ref, type: "checkbox", role: "switch", className: "sec-switch__input", ...rest }), _jsx("span", { className: "sec-switch__track", "aria-hidden": "true" }), _jsx("span", { className: "sec-switch__thumb", "aria-hidden": "true" })] }));
});
